import gql from 'graphql-tag'

export default gql`mutation ycmdMessageTrash($message_id: ID) {
	ycmdMessageTrash(message_id: $message_id) {
		status
	}
}`
